import { defaultGridColDef } from '@/helpers/grid.helper'
import { useGridReady } from '@/hooks/agGrid'
import { AgGridReact } from 'ag-grid-react'
import { useEffect, useState } from 'react'
import Pagination from '../Pagination'

interface DataGridWithPaginationProps {
	rowData: any
	columnDefs: any[]
	onSortChanged?: (event: any) => void
	onPageChange: (page: number, pageSize?: number) => Promise<void> | void
	className?: string
	rowHeight?: number
	/** Lets wrapText/autoHeight columns grow so full cell text is visible. */
	autoRowHeight?: boolean
	/** Stretch columns so they fill the grid width (no empty gap on the right). */
	fitGridWidth?: boolean
}

const DataGridWithPagination: React.FC<DataGridWithPaginationProps> = (props) => {
	const onGridReadyBase = useGridReady()
	const [pageSize, setPageSize] = useState(props.rowData?.pageSize ?? props.rowData?.PageSize ?? 20)

	useEffect(() => {
		const nextPageSize = props.rowData?.pageSize ?? props.rowData?.PageSize
		if (nextPageSize) {
			setPageSize(nextPageSize)
		}
	}, [props.rowData?.PageSize, props.rowData?.pageSize])

	const handlePageChange = (page: number) => props.onPageChange(page, pageSize)

	const handlePageSizeChange = (nextPageSize: number) => {
		setPageSize(nextPageSize)
		void props.onPageChange(1, nextPageSize)
	}

	const fitColumns = (api?: { sizeColumnsToFit?: () => void }) => {
		if (props.fitGridWidth) {
			api?.sizeColumnsToFit?.()
		}
	}

	return (
		<>
			<div className={`ag-theme-quartz w-full suppressCellSelection ${props.className}`.trim()}>
				<AgGridReact
					theme="legacy"
					rowData={props.rowData.data}
					columnDefs={props.columnDefs}
					onSortChanged={props.onSortChanged}
					onGridReady={(params) => {
						onGridReadyBase(params)
						fitColumns(params.api)
					}}
					onFirstDataRendered={(params) => fitColumns(params.api)}
					onGridSizeChanged={(params) => fitColumns(params.api)}
					autoSizeStrategy={props.fitGridWidth ? { type: 'fitGridWidth' } : undefined}
					suppressRowTransform={!props.autoRowHeight}
					domLayout="autoHeight"
					defaultColDef={defaultGridColDef}
					tooltipShowDelay={0}
					rowHeight={props.autoRowHeight ? undefined : props.rowHeight}
					enableCellTextSelection
					ensureDomOrder
				/>

				<Pagination currentPage={props.rowData.currentPage} totalPages={props.rowData.totalPages} hasPreviousPage={props.rowData.hasPreviousPage} hasNextPage={props.rowData.hasNextPage} pageSize={pageSize} onPageChange={handlePageChange} onPageSizeChange={handlePageSizeChange} />
			</div>
		</>
	)
}

export default DataGridWithPagination
